import Flickity from 'flickity';

class partnerTabs {
	constructor(config) {
		this.config = Object.assign({
			scope: '.partner_tabs',
			toggler: '.flickity-trigger',
			tableWrapper: 'figure.table'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.unwrapTables();
		this.addEventListeners();
	}

	unwrapTables() {
		this.$scope.find(`${this.config.tableWrapper} > table`).unwrap();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.toggler, this.toggleSlide.bind(this))
	}

	toggleSlide(event) {
		let $target = $(event.currentTarget);
		let button = $target.data('target');
		let $slide = this.$scope.find(`.flickity-slide#${button}`)
		let index = $slide.data('index');
		let flickity =  Flickity.data($('#second-carousel')[0]);
		flickity.select(index);
	}
}

export default new partnerTabs;